<template>
  <div id="course" class="course">
    <!-- Main -->
    <section v-if="course">
      <nav class="breadcrumb is-flex" aria-label="breadcrumbs">
        <li v-for="(step, index) in course.steps" :key="step._id">
          <article class="media" v-if="step.type === 'video'">
            <figure class="media-left">
              <p class="image is-18x18">
                <img
                  :src="course_step === step._id
                        ? `${$baseUrl}/img/online-training/media.svg`
                        : `${$baseUrl}/img/online-training/media-deactive.svg`
                    "
                />
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p
                  :class="course_step === step._id ? 'bolder' : ''"
                >{{ $t("ONLINE_TRAINING.COURSE.VIDEO") }}</p>
              </div>
            </div>
          </article>
          <article class="media" v-if="step.type === 'iframe'">
            <figure class="media-left">
              <p class="image is-18x18">
                <img
                  :src="course_step === step._id
                        ? `${$baseUrl}/img/online-training/lesson.svg`
                        : `${$baseUrl}/img/online-training/lesson-deactive.svg`
                    "
                />
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p
                  :class="course_step === step._id ? 'bolder' : ''"
                >{{ $t("ONLINE_TRAINING.COURSE.LESSON") }}</p>
              </div>
            </div>
          </article>
          <article class="media" v-if="step.type === 'assessment'">
            <figure class="media-left">
              <p class="image is-18x18">
                <img
                  :src="course_step === step._id
                        ? `${$baseUrl}/img/online-training/test.svg`
                        : `${$baseUrl}/img/online-training/test-deactive.svg`
                    "
                />
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p
                  :class="course_step === step._id ? 'bolder' : ''"
                >{{ $t("ONLINE_TRAINING.COURSE.ASSESSMENT") }}</p>
              </div>
            </div>
          </article>
          <img
            class="arrow"
            v-if="index + 1 !== course.steps.length"
            :src="`${$baseUrl}/img/online-training/arrow.svg`"
            alt
          />
        </li>
      </nav>

      <div v-for="step in course.steps" :key="step._id">
        <div v-if="course_step === step._id">
          <div v-if="step.type === 'video'">
            <Video />
          </div>
          <div v-if="step.type === 'assessment'">
            <Quiz :course_id="course._id" />
          </div>
          <div v-if="step.type === 'iframe'">
            <Lesson />
          </div>

          <div
            class="paginate-bar"
            v-if="
              !(step.type === 'assessment') &&
                course_step !== course.steps.length
            "
          >
            <div class="paginate-bar__content">
              <a class="is-half"></a>
              <div class="is-half">
                <b-button
                  v-if="course_step !== course.steps.length"
                  class="next-step"
                  type="is-primary"
                  @click.prevent="next()"
                >{{ $t("ONLINE_TRAINING.COURSE.BUTTON_CONFIRM") }}</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- end Main -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Lesson from "./Lesson";
import Video from "./Video";
import Quiz from "./Quiz";

export default {
  components: {
    Lesson,
    Video,
    Quiz
  },
  data() {
    return {
      course_step: 1, //default step = 1;
      loading: false,
      buttonLoading: false
    };
  },
  props: ["id"],
  computed: {
    ...mapGetters(["supplierToken", "courses", "course"])
  },
  methods: {
    init () {
      if (this.courses && this.courses.length > 0) {
        this.$store.dispatch("getCourse", this.$route.params.slug);
      }else{
        this.$store.dispatch("getAllCourses", this.supplierToken);
      }
    },
    
    next() {
      this.course_step++;
    },
    onChangeCourses (newVal, oldVal) {
      if (!this.course.slug && newVal && newVal !== oldVal) {
        this.$store.dispatch("getCourse", this.$route.params.slug);
      }
    }
  },
  created() {
    this.init()
  },
  mounted(){

  },
  watch: {
    courses(newVal, oldVal) {
      this.onChangeCourses(newVal, oldVal)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.content figure:not(:last-child) {
  margin-bottom: 0px;
}
.content li + li {
  margin-top: 0;
}
#course {
  -webkit-overflow-scrolling: touch;
}


.step-content {
  padding: 0 !important;
}
.breadcrumb li + li::before {
  content: "";
}
.media {
  align-items: center;

  img {
    width: 18px;
    height: 18px;
  }
}
.paginate-bar {
  width: 860px;
  height: 60px;
  position: fixed;
  bottom: 0;
  background-color: #142246;

  .paginate-bar__content {
    display: flex;
    justify-content: space-between;

    a {
      color: white;
      line-height: 20px;
      padding: 20px 15px;

      img {
        margin-right: 5px;
      }
      span {
        font-size: 13px;
      }
    }

    .next-step {
      width: 160px;
      height: 40px;
      font-weight: 500;
      margin: 10px;
    }
  }
}

.next-step.d-none {
  display: none;
}
.breadcrumb {
  height: 48px;
  padding: 12px 20px;
  background-color: white;
  margin-bottom: 12px;

  .arrow {
    margin: 0 16px;
  }
  .media-left {
    margin-right: 5px;
  }

  .media-content {
    .content {
      display: inline-block;
    }
    p {
      font-size: 14px;
      // display: none;
      color: #bcbcbc;
    }
    p.bolder {
      font-weight: 500;
      display: block;
      color: #ff8200;
    }
  }
}

@media only screen and (max-width: 600px) {
  .course {
    height: 100vh;
  }
}
@media only screen and (min-width: 601px) {
  .course {
    .video {
      height: calc(100vh - 140px);
    }
  }
}
@media screen and (max-width: 768px) {
   .paginate-bar {
    width: 100%;
    left: 0;
  }
}
@media screen and (min-width: 1024px) {
  #course {
    max-width: 960px;
    margin: 0 auto;
  }
}
</style>
